import { environment } from '@environments/environment';
import { Rescatable } from '../Rescatable';

export class FindAplications extends Rescatable {
  static _name = 'FindAplications';
  static pathRequest = `${environment.apiStatic}encontraTuEquipo`;
  static pk: keyof FindAplications = 'id';

  id: number;
  alias: string;
  busqueda: string;
  estado: number;
  abreviatura: string;
  id_genero: number;
  imagen: string;
  imagen_mini: string;
  titulo: string;
  puntaje?: number;
  constructor(findAplications: FindAplications) {
    super(findAplications);
  }
}
